/**
 * Btn — spec §F2 `Btn(variant: primary|ghost, size: md|sm, icon?)`.
 * Renders the mockup's `.btn` / `.btn.primary` / `.btn.ghost` / `.btn.sm` classes
 * (styles live in styles/base.css, lifted from the mockup).
 */
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Icon, type IconName } from '../lib/icons';

export interface BtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost';
  size?: 'md' | 'sm';
  icon?: IconName;
  children?: ReactNode;
}

export function Btn({
  variant = 'ghost',
  size = 'md',
  icon,
  children,
  className,
  type = 'button',
  ...rest
}: BtnProps) {
  const cls = ['btn', variant, size === 'sm' ? 'sm' : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={cls} {...rest}>
      {icon ? <Icon name={icon} size={14} /> : null}
      {children}
    </button>
  );
}
